import React, { useEffect, useState } from "react";
import { WiMoonAltWaningCrescent4 } from "react-icons/wi";


const Themetoggle = () => {
  // Safely get initial theme from localStorage with SSR check and default
  const getInitialTheme = () => {
    if (typeof window === "undefined") return "light";
    const storedTheme = localStorage.getItem("theme");
    return storedTheme === "dark" || storedTheme === "light" ? storedTheme : "light";
  };

  const [theme, settheme] = useState(getInitialTheme);
  
  const themetoggle = () => {
    settheme(prevTheme => prevTheme === "dark" ? "light" : "dark");
  };
  
  useEffect(() => {
    if (typeof window === "undefined") return;
    document.documentElement.setAttribute('data-theme', theme);
    localStorage.setItem('theme', theme); 
  }, [theme]);
  return (
    <div className="toggle_button" onClick={themetoggle}>
      <WiMoonAltWaningCrescent4 />
    </div>
  );
};

export default Themetoggle;
